import { render, staticRenderFns } from "./ModalOfflineError.vue?vue&type=template&id=5b06a460&scoped=true"
import script from "./ModalOfflineError.vue?vue&type=script&lang=js"
export * from "./ModalOfflineError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b06a460",
  null
  
)

export default component.exports